import { render, staticRenderFns } from "./ProductImageForm.vue?vue&type=template&id=2caa6f5d&scoped=true&"
import script from "./ProductImageForm.vue?vue&type=script&lang=js&"
export * from "./ProductImageForm.vue?vue&type=script&lang=js&"
import style0 from "./ProductImageForm.vue?vue&type=style&index=0&id=2caa6f5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2caa6f5d",
  null
  
)

export default component.exports